import { Target, Building2, Users2, CheckSquare, CalendarPlus, TrendingUp } from "lucide-react";

const LIFECYCLE = ["Prospect", "Lead", "Opportunity", "Advertiser", "Former Customer", "Archived"];

// Entity order used by the global + New menu.
export const QUICK_ADD_ORDER = ["lead", "business", "contact", "task", "meeting", "opportunity"];

export const QUICK_ADD = {
  lead: {
    label: "Lead", icon: Target, endpoint: "/leads", dedupe: "business_name",
    fields: [
      { name: "business_name", label: "Business Name", required: true, dedupe: true },
      { name: "phone", label: "Phone", dedupe: true },
      { name: "email", label: "Email", dedupe: true },
      { name: "city", label: "City" },
      { name: "territory", label: "Territory", type: "select", source: "territories" },
      { name: "zone", label: "Zone", type: "select", source: "zones" },
      { name: "status", label: "Status", type: "select", source: "lead_statuses", required: true, defaultFirst: true },
      { name: "priority", label: "Priority", type: "select", options: ["Hot", "Warm", "Cold"] },
      { name: "lead_source", label: "Lead Source", type: "select", source: "lead_sources" },
      { name: "assigned_to", label: "Assigned To", type: "combo", source: "users" },
      { name: "potential_value", label: "Potential Value", type: "number" },
      { name: "next_follow_up", label: "Next Follow-Up", type: "date" },
      { name: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  business: {
    label: "Business", icon: Building2, endpoint: "/businesses", dedupe: "name",
    fields: [
      { name: "name", label: "Business Name", required: true, dedupe: true },
      { name: "category", label: "Category" },
      { name: "phone", label: "Phone", dedupe: true },
      { name: "email", label: "Email", dedupe: true },
      { name: "city", label: "City" },
      { name: "province", label: "Province/State" },
      { name: "territory", label: "Territory", type: "select", source: "territories" },
      { name: "zone", label: "Zone", type: "select", source: "zones" },
      { name: "lifecycle", label: "Lifecycle", type: "select", options: LIFECYCLE, required: true, default: "Lead" },
      { name: "assigned_to", label: "Assigned To", type: "combo", source: "users" },
    ],
  },
  contact: {
    label: "Contact", icon: Users2, endpoint: "/contacts",
    fields: [
      { name: "first_name", label: "First Name", required: true },
      { name: "last_name", label: "Last Name" },
      { name: "title", label: "Title" },
      { name: "business_id", label: "Business", type: "combo", source: "businesses" },
      { name: "email", label: "Email" },
      { name: "phone", label: "Phone" },
      { name: "mobile", label: "Mobile" },
      { name: "preferred_method", label: "Preferred Method", type: "select", options: ["Phone", "Email", "Mobile", "In Person"] },
      { name: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  task: {
    label: "Task", icon: CheckSquare, endpoint: "/tasks", defaults: { status: "Open" },
    fields: [
      { name: "title", label: "Title", required: true },
      { name: "business_id", label: "Business", type: "combo", source: "businesses" },
      { name: "assigned_to", label: "Assigned To", type: "combo", source: "users" },
      { name: "due_date", label: "Due Date", type: "date" },
      { name: "priority", label: "Priority", type: "select", options: ["High", "Medium", "Low"], default: "Medium" },
      { name: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  meeting: {
    label: "Meeting", icon: CalendarPlus, endpoint: "/events", defaults: { type: "Meeting" },
    fields: [
      { name: "title", label: "Title", required: true },
      { name: "business_id", label: "Business", type: "combo", source: "businesses" },
      { name: "start", label: "Start", type: "datetime", required: true },
      { name: "end", label: "End", type: "datetime" },
      { name: "location", label: "Location" },
      { name: "assigned_to", label: "Assigned To", type: "combo", source: "users" },
      { name: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
  opportunity: {
    label: "Opportunity", icon: TrendingUp, endpoint: "/opportunities", defaults: { status: "Open" },
    fields: [
      { name: "name", label: "Opportunity Name", required: true },
      { name: "business_id", label: "Business", type: "combo", source: "businesses", required: true },
      { name: "contact_id", label: "Primary Contact", type: "combo", source: "contacts", scopeByBusiness: true },
      { name: "stage", label: "Stage", type: "select", source: "pipeline_stages", required: true, defaultFirst: true },
      { name: "expected_value", label: "Expected Value", type: "number" },
      { name: "product", label: "Product", type: "select", source: "products" },
      { name: "territory", label: "Territory", type: "select", source: "territories" },
      { name: "zone", label: "Zone", type: "select", source: "zones" },
      { name: "expected_close", label: "Expected Close", type: "date" },
      { name: "assigned_to", label: "Salesperson", type: "combo", source: "users" },
      { name: "lead_source", label: "Lead Source", type: "select", source: "lead_sources" },
      { name: "notes", label: "Notes", type: "textarea", full: true },
    ],
  },
};
